import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InfiniteScroll from "react-infinite-scroll-component";
import { UiComponents, defaultLogo } from '@simulanisindia/ui';
import FilterManagement from '../FilterManagement';
import { checkDataInList } from '../../Utils/general';
import { setToggleApplication } from '../../Store/slice/subscriptionSlice';

const { SearchBar } = UiComponents;

const ApplicationList = ({ selectedCheckboxes, showFilter = true, openFilter, hasMore, loadMoreData, search, setSearch, renderList, filterOptions }) => {
  const { SimCheckBox } = UiComponents;
  const dispatch = useDispatch();
  const { checkedApplication } = useSelector((state) => state.subscriptionSlice);

  const [list, setList] = useState([]);

  useEffect(() => {
    setList(renderList);
  }, [renderList]);

  const handleCheckboxChange = (item) => {
    dispatch(setToggleApplication({ data: item }));
  };

  return (
    <>
      <div className="colorborder">
        <div className="newsubs-application newsubs-module">
          <div className="newsubs-module-header">
            <div className='module-left'>
              <h5>Application</h5>
              <p>Select the application you want to assign to a group, and role</p>
            </div>
            <div className='module-right'>
              <div className="searchwithborder">
                <SearchBar
                  onClick={() => { }}
                  placeholder={`Search Application...`}
                  value={search}
                  onChange={(e) => setSearch(e)}
                />
              </div>
              {showFilter && <FilterManagement openFilter={openFilter} selectedCheckboxes={selectedCheckboxes} />}
            </div>
          </div>

          <div className='application-content-list' id="scrollableDivResources">
            <InfiniteScroll
              scrollThreshold={0.7}
              dataLength={list.length}
              next={() => loadMoreData()}
              hasMore={hasMore}
              // loader={<ResourceManagementSkelton length="4" width={activeTab === RESOURCE_APPLICATION_TAB ? "50px" : "70px"} circle={activeTab === RESOURCE_APPLICATION_TAB ? true : false} />}
              loader={<p>Loading....</p>}
              scrollableTarget="scrollableDivResources"
            >
              <>
                {list.map((item) => (
                  <div key={item.id} className="newsubs-application-list">
                    <span>
                      <SimCheckBox
                        checked={checkDataInList(checkedApplication, item)}
                        onChange={() => handleCheckboxChange(item)}
                      />
                    </span>
                    <div className="appthumb">
                      <img src={item.icon || defaultLogo} alt={item.title} />
                    </div>
                    <div className="appdata">
                      <h5>{item.title}</h5>
                      {/* <p>{item.description}</p> */}
                    </div>
                  </div>
                ))}
              </>
            </InfiniteScroll>
          </div>

        </div>

      </div>
    </>
  );
};

export default ApplicationList;
